import apiClient, { getDisabilitiesList } from "../../../../../services/apiClient";

export async function getSpecializations() {

    const url = 'specializations';

    const ret = await apiClient.get(url);

    if(!ret || !ret.data) return [];

    return ret.data.filter(r=>r.isActive).map(r=>({ value: r._id, name: r.name }));
    
}

export function getDisabilities() {
    return getDisabilitiesList();
}


export async function getAcademicYears() {
    const url = 'references/academic-years?status=active';
    
    try {
        const ret = await apiClient.get(url);
        
        if (!ret || !ret.data || !ret.data.data) return [];
        
        return ret.data.data.map(year => ({
            value: year._id,
            name: year.name,
            year: year.additionalFields.year,
            groupFormationStart: year.additionalFields.groupFormationStart
        }));
    } catch (error) {
        console.error('Error fetching academic years:', error);
        return [];
    }
}


export async function getAttendsInfo({kg_id}){

        const curDate = new Date();

        const period = [curDate.getMonth() + 1, curDate.getFullYear()].join('.');

        let url = `attend_group_period?kg_id=${kg_id}&period=${period}`;

        const tabel_curdate = {};
              const tabel_info = {};
              const days_info = {};

        const out_obj = {tabel_curdate, tabel_info, tabel_days:{} };

        try {
            const ret = await apiClient.get(url);
        
            if (!ret || !ret.data) return out_obj;


            for (let info of ret.data) {
                if(!tabel_curdate[info._id.idGr]) tabel_curdate[info._id.idGr] = 0;
                if(!tabel_info[info._id.idGr]) tabel_info[info._id.idGr] = 0;
                if(!days_info[info._id.idGr]) days_info[info._id.idGr] = {};

                if(!days_info[info._id.idGr][new Date(info._id.date).toLocaleDateString('uk')]) days_info[info._id.idGr][new Date(info._id.date).toLocaleDateString('uk')] = 1; 

                if( new Date( info._id.date ).toLocaleDateString('uk') === curDate.toLocaleDateString('uk') ) tabel_curdate[info._id.idGr] += info.attend;
                tabel_info[info._id.idGr] += info.attend;
            }

            const num_days_attends = {};

            for(let gr of Object.keys(days_info) ) {
                num_days_attends[gr] = Object.keys( days_info[gr] ).length;
            }

            out_obj['tabel_days'] = num_days_attends;

            return out_obj;
            
    } catch (error) {
        console.error('Error fetching academic years:', error);
        return [];
    }
}

export async function resetPlacesGroup(kindergartenId){
    
    const url = `kindergartens/${kindergartenId}/flash`;

    try {

        const ret = await apiClient.post(url,{});
        
        return ret;

    } catch (error) {

        console.error('Error fetching academic years:', error);
        return null;

    }
}

    